import $ from 'domtastic'
import 'smartbanner.js/dist/smartbanner.js'

// Add class to body when smartbanner is shown and update
// view button to open in same window (target=_blank doesn't work)
document.addEventListener('smartbanner.view', () => {
  $('body').addClass('smartbanner-open')
  $('.smartbanner__button').removeAttr('target')
})

// Remove class to body when smartbanner is closed
document.addEventListener('smartbanner.exit', () => {
  $('body').removeClass('smartbanner-open')
})
